<template>
  <section class="viewsrhqyClockManage_VehicleReport space-y-4 p-4">
    <viewTitle
      title="业务管理 / 发货打卡管理 / 车辆报备管理"
      :showReturn="false"
    >
    </viewTitle>
    <div class="text-center">
      <el-radio-group v-model="queryParam.state" size="medium">
        <el-radio-button
          v-for="(item, key) in stateMap"
          :key="key"
          :label="key"
        >
          <el-badge :is-dot="key == 1 && stateCount[key] > 0" class="item">
            <span class="px-2">
              {{ item }}
              <template v-if="stateCount[key] > 0">
                ({{ stateCount[key] }})
              </template>
            </span>
          </el-badge>
        </el-radio-button>
        <el-radio-button label="">已删除</el-radio-button>
      </el-radio-group>
    </div>
    <el-form
      :inline="true"
      :model="queryParam"
      class="search-form-inline-small"
    >
      <el-form-item>
        <el-input
          clearable
          v-model="queryParam.keyword"
          placeholder="输入供应商/木片厂名"
          suffix-icon="el-icon-search"
          class="w-64"
        ></el-input>
      </el-form-item>
      <el-form-item label="基地" v-if="baseInfo.is_main_com === 1">
        <el-select
          class="w-40"
          placeholder="请选择基地"
          clearable
          v-model="queryParam.delivery_com_id"
        >
          <el-option
            v-for="item in com_list"
            :key="item.com_id"
            :label="item.com_name"
            :value="item.com_id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <div class="float-right space-x-2">
        <el-button
          @click="onAddCar"
          v-has="['c-clock-report-add']"
          type="primary"
          size="small"
          v-if="baseInfo.is_main_com === 0"
        >
          添加车辆
        </el-button>
        <el-button
          @click="onExport"
          v-has="['c-clock-report-export']"
          size="small"
        >
          批量导出
        </el-button>
      </div>
    </el-form>
    <c-table
      class="mt-4"
      :isIndex="false"
      :isSelection="false"
      :selection.sync="rowKeySelection"
      :data="dataSource"
      :columns="columns"
      :query.sync="pagintion"
      :total="total"
      row-key="booking_id"
      @loadPage="loadData"
    >
      <template slot="create_time" slot-scope="{ row }">
        {{ row.create_time | timeFormat }}
      </template>
      <template slot="approval_time" slot-scope="{ row }">
        {{ row.approval_time | timeFormat }}
      </template>
      <template slot="use_time" slot-scope="{ row }">
        {{ row.use_time | timeFormat }}
      </template>
      <template slot="action" slot-scope="{ row }">
        <div class="space-x-4">
          <c-link
            v-has="['c-clock-report-detail']"
            @click="onView(row)"
            type="primary"
            label="查看"
          ></c-link>
          <c-link
            v-if="row.info_state == 1 && row.state == 1"
            @click="onAppr(row)"
            type="primary"
            v-has="['c-clock-report-approval']"
            label="审批"
          ></c-link>
          <c-link
            v-if="row.info_state == 1 && row.state == 2"
            @click="onUsed(row)"
            v-has="['c-clock-report-use']"
            type="primary"
            label="使用"
          ></c-link>
          <c-link
            v-if="row.info_state == 1"
            @click="onDelete(row, true)"
            type="primary"
            label="删除"
            v-has="['c-clock-report-delete']"
          ></c-link>
        </div>
      </template>
    </c-table>
    <el-dialog title="删除" :visible.sync="del_visible" width="650px">
      <el-form
        ref="del_form"
        :rules="delRules"
        :model="del_form"
        label-width="100px"
      >
        <el-form-item label="原因" prop="close_reason">
          <el-input
            class="w-96"
            type="textarea"
            :autosize="{ minRows: 4 }"
            placeholder="请输入原因"
            v-model="del_form.close_reason"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="del_visible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="onDelConfirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog title="审批" :visible.sync="appr_visible" width="650px">
      <el-form ref="appr_form" :model="appr_form" label-width="100px">
        <el-form-item required label="审批结果" prop="approval_result">
          <el-radio-group v-model="appr_form.approval_result">
            <el-radio :label="1">同意</el-radio>
            <el-radio :label="2">不同意</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="备注" prop="approval_remark">
          <el-input
            type="textarea"
            :rows="2"
            class="w-96"
            placeholder="请输入内容"
            v-model="appr_form.approval_remark"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="appr_visible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="onApprConfirm"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </section>
</template>

<script>
import initListMinxin from "@/mixins/jl/initListMinxin";
import mixinTableLyout from "@/views/rhqy/config/mixinTableLyout";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      appr_visible: false,
      appr_form: {
        id: "",
        approval_result: 1,
        approval_remark: ""
      },
      del_visible: false,
      del_form: {
        id: "",
        close_reason: ""
      },
      delRules: {
        close_reason: [
          {
            required: true,
            message: "原因不能为空！"
          }
        ]
      },
      queryParam: {
        state: "1"
      },
      stateMap: {
        "1": "待审批",
        "2": "已启用",
        "3": "已使用",
        "4": "已拒绝"
      },
      stateCount: {
        "1": 0,
        "2": 0,
        "3": 0,
        "4": 0
      },
      columns: [
        { label: "基地", prop: "delivery_com_name" },
        {
          label: "报备类型",
          prop: "type",
          formatData: row => (row.type == 1 ? "白名单" : "未打卡车辆")
        },
        { label: "车辆号", prop: "license_plate" },
        {
          label: "状态",
          prop: "state",
          formatData: row => this.stateMap[row.state]
        },
        { label: "添加原因", prop: "add_reason" },
        {
          label: "创建时间",
          prop: "create_time"
        },
        { label: "审批时间", prop: "approval_time" },
        { label: "使用时间", prop: "use_time" },
        { width: 140, label: "操作", prop: "action" }
      ],
      exportDataEvent: params => {
        return this.$common.http({
          url: "/api/queue/admin/export_car_report",
          data: {
            ...params,
            info_state: params.state ? 1 : 0
          },
          noLoading: true
        });
      },
      fetchDataEvent: params =>
        this.$common.http({
          url: "/api/queue/admin/query_car_report",
          data: {
            ...params,
            info_state: params.state ? 1 : 0
          }
        }),
      loadCallBack: this.getCount
    };
  },

  computed: {
    ...mapGetters(["baseInfo"])
  },

  watch: {},

  components: {},

  mixins: [initListMinxin, mixinTableLyout],

  beforeCreate() {},

  created() {},

  beforeMount() {},

  mounted() {},

  activated() {},

  deactivated() {},

  methods: {
    getCount() {
      this.$common
        .http({
          url: "/api/queue/admin/count_car_report",
          noLoading: true
        })
        .then(res => {
          console.log(res.data.data);
          this.stateCount["1"] = res.data.data["wait_approval"];
          this.stateCount["2"] = res.data.data["enable"];
          this.stateCount["3"] = res.data.data["used"];
          this.stateCount["4"] = res.data.data["refuse"];
        });
    },
    onAddCar() {
      this.$router.push({
        path: "/rhqy/service/clockIn/VehicleReportDetail/0"
      });
    },
    onView(row) {
      this.$router.push({
        path: "/rhqy/service/clockIn/VehicleReportDetail/" + row.id
      });
    },
    onAppr(row) {
      this.appr_form = {
        id: row.id,
        approval_result: 1,
        approval_remark: ""
      };
      this.appr_visible = true;
    },
    async onApprConfirm() {
      try {
        await this.$common.http({
          url: "/api/queue/admin/approval_car_report",
          data: this.appr_form
        });
        this.appr_visible = false;
        this.$message({
          message: "操作成功",
          type: "success"
        });
        this.loadData();
      } catch (error) {}
    },
    onUsed(row) {
      this.$confirm(`确认使用吗？`, "提示").then(async () => {
        try {
          await this.$common.http({
            url: "/api/queue/admin/use_car_report",
            data: {
              id: row.id
            }
          });
          this.$message({
            message: "操作成功",
            type: "success"
          });
          this.loadData();
        } catch (error) {}
      });
    },
    onDelete(row) {
      this.del_form = {
        id: row.id,
        close_reason: ""
      };
      this.del_visible = true;
    },
    onDelConfirm() {
      this.$refs.del_form.validate(async v => {
        if (v) {
          try {
            await this.$common.http({
              url: "/api/queue/admin/delete_car_report",
              data: this.del_form
            });
            this.del_visible = false;
            this.$message({
              message: "操作成功",
              type: "success"
            });
            this.loadData();
          } catch (error) {}
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding: 0 15px !important;
}
</style>
